import { lazy } from "react";

const OrdenTrabajoLayout = lazy(() =>
      import("../../ordentrabajo/OrdenTrabajoLayout.jsx")
);

const OrdenTrabajoLista = lazy(() =>
      import("../../ordentrabajo/OrdenTrabajoLista.jsx")
);

const OrdenTrabajoForm = lazy(() =>
      import("../../ordentrabajo/OrdenTrabajoForm.jsx")
);

const ordenTrabajoRoutes = [
      {
            path: "ventas/ordentrabajo",
            element: <OrdenTrabajoLayout />,
            children: [
                  { index: true, element: <OrdenTrabajoLista /> },
                  { path: "nueva", element: <OrdenTrabajoForm /> },
                  { path: "editar/:token", element: <OrdenTrabajoForm /> },
            ],
      },
];

export default ordenTrabajoRoutes;
